import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import agentImage from "../../../../assets/Images/Mask group.png";
import UIAvatar from "./DoctorAvatar";

import MiaInlineWidget from "./MiaInlineWidget";

const MIAgent = ({ onFirstConnected }) => {
  const doctorName = "Mia";
  const doctorRole = "AI Voice Intake Agent";
  const doctorCategory = "Medical History";
  const [isOnline, setIsOnline] = useState(false);
  const [isMuted, setIsMuted] = useState(false);

  const [hasNotifiedFirstOnline, setHasNotifiedFirstOnline] = useState(false);

  // Notify parent (e.g., QuestionnaireForm) the first time the
  // Mia VoiceAgent reports being online/connected.
  React.useEffect(() => {
    if (isOnline && !hasNotifiedFirstOnline) {
      setHasNotifiedFirstOnline(true);
      if (typeof onFirstConnected === "function") {
        onFirstConnected();
      }
    }
  }, [isOnline, hasNotifiedFirstOnline, onFirstConnected]);

  return (
    <Box
      sx={{
        bgcolor: "#446566",
        borderRadius: 4,
        padding: "1rem",
        color: "#F9FAFB",
        maxWidth: 380,
        mx: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        // gap: 3,
      }}
      className="h-100"
    >
      {/* Header */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: 12,
          color: "#E5E7EB",
        }}
      >
        <Typography variant="caption" sx={{ fontWeight: 500 }}>
          Intake Assistant
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              bgcolor: "#FBBF24",
            }}
          />
          <Typography variant="caption" sx={{ fontWeight: 500 }}>
            Here to Help
          </Typography>
        </Box>
      </Box>

      {/* Avatar */}
      <Box sx={{ mt: 1 }}>
        <UIAvatar
          name={doctorName}
          isOnline={isOnline}
          showStatus
          onlineText={isMuted ? "MUTED" : "LIVE"}
          offlineText="OFFLINE"
          size={"12rem"}
          src={agentImage}
        />
      </Box>

      {/* Doctor info */}
      <Box sx={{ textAlign: "center" }}>
        <Typography
          variant="h6"
          sx={{ fontWeight: 600, mb: 0.5, color: "#F9FAFB" }}
        >
          {doctorName}
        </Typography>
        <Typography variant="body2" sx={{ color: "#E5E7EB", mb: 1 }}>
          {doctorRole}
        </Typography>
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            px: 2,
            py: 0.5,
            borderRadius: "999px",
            bgcolor: "#EFF6FF",
            color: "#1F2937",
            fontSize: 12,
            fontWeight: 500,
          }}
        >
          {doctorCategory}
        </Box>
      </Box>

      {/* Visualizer placeholder */}
      {/* <Box
        sx={{
          width: "100%",
          mt: 1,
          mb: 1,
          px: 2,
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: 32,
            borderRadius: 999,
            background:
              "linear-gradient(90deg, rgba(249,250,251,0.1) 0%, rgba(249,250,251,0.6) 50%, rgba(249,250,251,0.1) 100%)",
            opacity: 0.9,
          }}
        />
      </Box> */}

      {/* Transcript / chat section */}
      <Box>
        {/* <MiaVoiceAgentWidget /> */}

        <MiaInlineWidget
          tenantId="cr-ai-research-h7igh"
          agentName="Mia"
          formId="Questionnaire/842d26e6-5cda-4776-9a67-dc3beadd462a"
          patientName="Maria Lopez"
          setIsOnline={setIsOnline}
          isOnline={isOnline}
          setIsMuted={setIsMuted}
        />
      </Box>
    </Box>
  );
};

export default MIAgent;
